import React from 'react';
import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash';
import ShowAllEventsProvider from 'context/dash/ShowAllEvents';
import DetailVisibleProvider from 'context/dash/DetailVisible';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import TeamsPage from 'modules/dashboard/producer/teams/TeamsPage';

export default function DashTeams() {
    return (
        <BackButtonCollapseDashProvider>
            <ShowAllEventsProvider>
                <DetailVisibleProvider>

                    <DashContainer title='Equipes'>
                        <TeamsPage />
                    </DashContainer>

                </DetailVisibleProvider>
            </ShowAllEventsProvider>
        </BackButtonCollapseDashProvider>
    );
}
